import React from "react";
import Copyright from "../components/footer/Copyright";
import NavbarTwo from "../components/NavbarTwo";
import PrivacyRepo from "../repository/PrivacyRepo";

const Privacy = () => {
  let bgImage = process.env.PUBLIC_URL + "assets/media/bg-image-2.4b2b6c28.JPG";
  return (
    <>
      <NavbarTwo />
      <div
        className="page-are"
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: `no-repeat`,
          backgroundPosition: `top`,
          backgroundSize: `cover`,
        }}
      >
        <div className="page-bg">
          <div
            className="container"
            style={{ paddingBottom: "100px", paddingTop: "118px" }}
          >
            <div className="row">
              <div className="col-lg-12 border border-secondary">
                <div className="section-title mb--40">
                  <h2 className="text-white mt-4 text-center">
                    <span className="theme-color">OUR</span> Privacy
                  </h2>
                  <div className="mt-4">
                    <div className="mt-4">
                      <h3 className="text-white">Scope of policy</h3>
                      <span className=" text-white">
                        This privacy policy (Policy) together with our Terms of
                        Use applies to your use of:
                      </span>
                      <p>&nbsp;</p>
                      {PrivacyRepo.policyScope.map((scope, index) => (
                        <div className="text-white" key={index}>
                          {scope.desc}
                          <p>&nbsp;</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  {PrivacyRepo.privacyRepo.map((privacy, index) => (
                    <div key={index}>
                      <p>&nbsp;&nbsp;</p>
                      <h3 className="text-light">{privacy.title}</h3>
                      <div className="text-white">{privacy.description}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <Copyright />
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
